import t from"./Stats.vue_vue&type=script&lang.js";import{render as e}from"./Stats.vue_vue&type=template&id=6d9c672c&lang.js";t.render=e;export default t;
//# sourceMappingURL=Stats.vue.js.map
